import { Component, ElementRef, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { OnboardingProductsStore } from '../../../store/store';
import {
  PassiveDocumentCreationActions,
  CigoActions,
  UiActions,
} from '../../../store/actions';
import html2pdfJs from 'html2pdf.js';
import { DataClientService } from '../../../services/data-client.service';
import { LoadingService } from '../../../services/loading.service';
import { SessionService } from '../../../services/session.service';
import { ApiResponseStatus, StepsClientTypes } from '../../../shared/enums';
import { DatePipe } from '@angular/common';
import { NgbModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { SuccessProcessHandler } from '../../bfpe-common/success-process/handler/success-process.handler';
import { Subscription } from 'rxjs';
import { ResponseSuccessProcess } from '../../../shared/interfaces/successProcess.interface';
import { RedirectService } from '../../../services/redirect.service';
import { AccountFormatService } from '../../../services/account-format.service';
import { TagPage } from '../../../store/actions/ui.actions';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-client-step-config4-mobile',
  templateUrl: './client-step-config4-mobile.component.html',
  styleUrls: ['../../../global.scss', './client-step-config4-mobile.component.scss']
})
export class ClientStepConfig4MobileComponent implements OnInit, OnDestroy {

  @ViewChild('personalDataModal', { read: TemplateRef }) personalDataModal: TemplateRef<any>;
  @ViewChild('t') tooltip: NgbTooltip;
  @ViewChild('voucherPDF', { static: false }) voucherPDF: ElementRef;
  pdf: ArrayBuffer;
  closeResult = '';
  isJointAccount: boolean;
  identificationType: string;
  identificationNumber: string;
  name: string;
  surname: string;
  identificationTypeJoint: string;
  identificationNumberJoint: string;
  nameJoint: string;
  surnameJoint: string;
  accountType: string;
  currencyType: number;
  openingDate: string | null;
  flowAccountName: string;
  staticBullets: string[];
  textResponse$: ResponseSuccessProcess;
  subs = new Subscription();
  staticAssetsUrl = environment.staticScripts.staticAssets;


  public accountNumber: string;
  public CCI: string;

  passiveDocumentCreation$ = this.store.pipe(
    select(OnboardingProductsStore.selectors.passiveDocumentCreation)
  );

  cigoSuscription$ = this.store.pipe(
    select(OnboardingProductsStore.selectors.cigo)
  );

  constructor(
    private store: Store<OnboardingProductsStore.AppState>,
    private dataClientService: DataClientService,
    public loadingService: LoadingService,
    public sessionService: SessionService,
    public accountFormatService: AccountFormatService,
    private redirectService: RedirectService,
    private elementRef: ElementRef,
    private datePipe: DatePipe,
    private modalService: NgbModal,
    private successProcessHandler: SuccessProcessHandler
  ) { }

  passiveDocumentCreationSuscription = this.passiveDocumentCreation$.subscribe(({ response, error }) => {
    // error case
    if (error != null) {
      this.redirectService.setRedirect(StepsClientTypes.STEP_OFFER);
      this.store.dispatch(PassiveDocumentCreationActions.cleanState());
      this.store.dispatch(UiActions.Navigate({ step: StepsClientTypes.STEP_SERVICE_ERROR }));
      this.loadingService.loading = false;
    }

    if (
      response != null &&
      response.client.data
    ) {
      this.store.dispatch(PassiveDocumentCreationActions.cleanState());
      this.loadingService.loading = false;
      this.downloadPDF(response.client.data.provisionContract.document.fileBase64, 'contrato_prestacion_servicios_bancarios_cartilla_informativa.pdf');
    }
  });

  cigoSuscription = this.cigoSuscription$.subscribe(({ response, error }) => {
    // error case
    if (error != null) {
      this.redirectService.setRedirect(StepsClientTypes.STEP_OFFER);
      this.store.dispatch(CigoActions.cleanState());
      this.store.dispatch(UiActions.Navigate({ step: StepsClientTypes.STEP_SERVICE_ERROR }));
      this.loadingService.loading = false;
    }
    // succes case
    if (response != null && response.client.operationState.code === ApiResponseStatus.OK) {
      this.dataClientService.setEmail(response.client.data.informacionContacto.correoElectronico[0].direccionCorreoElectronico);

      this.name = response.client.data.primerNombre;
      this.surname = response.client.data.apellidoPaterno;

      this.store.dispatch(CigoActions.cleanState());
      this.loadingService.loading = false;
    }
  });

  ngOnInit() {
    this.subs.add(this.successProcessHandler.getBullets().subscribe((data: ResponseSuccessProcess) => {
      this.textResponse$ = data;
      this.setBullets();
    }));
    this.accountType = this.accountFormatService.getName();
    this.store.select('stepsClient').subscribe();
    this.accountFormatService.getAccountNameFromAssets().subscribe((accountTitle) => {
      this.flowAccountName = accountTitle;
    });
    // set data for voucher
    this.identificationType = this.dataClientService.getCigoData().documentoIdentidad.tipoDocumento;
    this.identificationNumber = this.dataClientService.getCigoData().documentoIdentidad.numeroDocumento;
    this.currencyType = this.dataClientService.getCurrencyType();
    this.openingDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.accountNumber = this.dataClientService.getAccountNumber();
    this.CCI = this.dataClientService.getCCI();

    this.name = this.dataClientService.getCigoData().primerNombre;
    this.surname = this.dataClientService.getCigoData().apellidoPaterno;

    // JOINT ACCOUNT
    if (this.dataClientService.isIsJointAccount()) {
      this.isJointAccount = true;
      this.identificationTypeJoint = this.dataClientService.getIdentificationTypeJoint();
      this.identificationNumberJoint = this.dataClientService.getIndentificationNumberJoint();
      this.nameJoint = this.dataClientService.getCigoDataJoint().primerNombre;
      this.surnameJoint = this.dataClientService.getCigoDataJoint().apellidoPaterno;
    }
    this.loadingService.loading = false;
    this.store.dispatch(TagPage({text: 'finalexitoso'}));
  }

  ngOnDestroy() {
    this.cigoSuscription.unsubscribe();
    this.passiveDocumentCreationSuscription.unsubscribe();
  }

  downloadContract() {
    this.loadingService.loading = true;
    this.getPassiveDocumentCreation();
  }

  public async printVoucher() {
     const pdfContainer = this.elementRef.nativeElement.children[1].children[0];

     const newHtml = pdfContainer.cloneNode(true);
     newHtml.style.display = 'block';
     const opt = {
      filename: `comprobante.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { width: 600, height: 750, y: 0, scrollY: 0 },
      jsPDF: { unit: 'mm', format: 'letter', orientation: 'p' }
    };
    // TODO: No es la mejor forma, pero detecte que se borra el operation, asi se vuelve asignar el valor
    //        y se regresa el page a voucher
     setTimeout(() => {
      // this.operationService.setOperationSubject(this.operation);
      // this.statePage.page = StepsEnum.voucher;
    });

     await  html2pdfJs().from(newHtml).set(opt).outputPdf().then((pdf) => {
      this.loadingService.loading = false;
      const newpdf = btoa(pdf);
      this.pdf = this.base64ToArrayBuffer(newpdf);
      this.modalService.open(this.personalDataModal, {ariaLabelledBy: 'modal-basic-title', windowClass: 'onboarding-pdf-data-modal', size: 'lg'}).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
      });
    });

    // TODO: No es la mejor forma, pero si se deja afuera, nunca cierra el loading
    // setTimeout(() => this.loaderService.hide());
  }

  private base64ToArrayBuffer(base64) {
    const binary_string =  window.atob(base64);
    const len = binary_string.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++)        {
        bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }

  private downloadPDF(pdf, fileName) {
    this.pdf = this.base64ToArrayBuffer(pdf);
    this.modalService.open(this.personalDataModal, {ariaLabelledBy: 'modal-basic-title', windowClass: 'onboarding-pdf-data-modal', size: 'lg'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
    });
  }

  setBullets() {
    const bulletsMap: Record<string, string[]> = {
      Ahorro: this.textResponse$?.clasicaBullets,
      Flex: this.textResponse$?.privateBullets,
      AhorroSueldo: this.textResponse$?.salaryAccountBullets,
      Ejecutiva: this.textResponse$?.executiveBullets,
      CTS: this.textResponse$?.ctsBullets
    };
    this.staticBullets = bulletsMap[this.accountType] ?? this.textResponse$?.privateBullets;
  }

  getPassiveDocumentCreation() {
    const request = {};
    this.store.dispatch(PassiveDocumentCreationActions.getPassiveDocumentCreation({ request }));
  }

  copyAccountNumber() {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = this.accountNumber;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.showTooltip();
  }

  showTooltip() {
    this.tooltip.open();
    setTimeout(() => {
      this.tooltip.close();
    }, 1000);
  }
}




